import { intakeConsentStatement } from "@kollectivia/shared";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { IntakeChrome } from "./_parts/IntakeChrome";

export function PrivacyNoticePage(): JSX.Element {
  const [params] = useSearchParams();
  const language = params.get("lang") === "en" ? "en" : "fr";
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (i18n.resolvedLanguage !== language) void i18n.changeLanguage(language);
  }, [i18n, language]);

  return (
    <IntakeChrome>
      <article lang={language} className="space-y-5 break-words">
        <h1 className="text-2xl font-semibold">{t("privacy_notice.title", { lng: language })}</h1>
        <p role="note" className="rounded-lg border border-amber-300 bg-amber-50 p-4">
          {t("privacy_notice.warning", { lng: language })}
        </p>
        <h2 className="text-lg font-semibold">
          {t("privacy_notice.declaration", { lng: language })}
        </h2>
        <blockquote className="border-l-4 pl-4">{intakeConsentStatement(language).text}</blockquote>
        <p>{t("privacy_notice.evidence", { lng: language })}</p>
        <h2 className="text-lg font-semibold">
          {t("privacy_notice.missingTitle", { lng: language })}
        </h2>
        <ul className="list-disc space-y-2 pl-5">
          {[1, 2, 3, 4].map((item) => (
            <li key={item}>{t(`privacy_notice.missing_${item}`, { lng: language })}</li>
          ))}
        </ul>
        <p>{t("privacy_notice.next", { lng: language })}</p>
      </article>
    </IntakeChrome>
  );
}
